import '../css/login.css';
import '../css/index.css';
import logo from '../img/logo-softmining.svg';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login } = useAuth();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            // Chiama la funzione login dal contesto
            await login(email, password);
            console.log('Login effettuato con successo');
            navigate('/dashboard');
        } catch (err) {
            // Mostra un messaggio di errore se il login fallisce
            console.error('Errore durante il login:', err.message);
            setError('Invalid email or password');
        }
    };

    return (
        <div className="form-container">
            <div className="form formLogin">
                <img src={logo} className="sign-logo" alt="logo" />
                <h2 className="titolo TitoloLogin">SIGN IN</h2>
                <form onSubmit={handleLogin}>
                    <label className="text" htmlFor="email">E-mail</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Enter your email..."
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <label className="text" htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="Enter your password..."
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    {error && <p className="error-message">{error}</p>}

                    <button type="submit" className="sign-button button">Sign in</button>
                </form>
                <div className="footer-form">
                    <div className="divleftFooterForm">
                        <Link className="textlink textLinkSign" to="/signup">Sign up</Link>
                    </div>
                    <div className="divrightFooterForm">
                        <Link className="textlink textLinkSign" to="/forgot-password">Forgot your password?</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
